import { Button, Modal } from 'antd';
import styled from 'styled-components';
import { COLOR, FONT_SIZE, RADIUS, SPACING } from '../../../constants/theme';

export const DialogModal = styled(Modal)`
  /* On phones a tall dialog scrolls to the screen's foot; keep its buttons
     clear of the chat launcher there. */
  @media (max-width: 480px) {
    top: ${SPACING.lg};
    padding-bottom: 88px;
  }

  .ant-modal-content {
    border-radius: ${RADIUS.modal};
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.22);
    overflow: hidden;
    color: ${COLOR.text};
  }

  .ant-modal-body {
    padding: 0;
  }

  .ant-modal-close {
    top: 12px;
    right: 12px;
  }

  .ant-modal-close-x {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: ${RADIUS.md};
    font-size: 18px;
    line-height: 1;
    color: ${COLOR.textMuted};
  }

  .ant-modal-close:hover .ant-modal-close-x {
    background: ${COLOR.mutedBackground};
    color: ${COLOR.text};
  }
`;

export const DialogBody = styled.div`
  padding: 28px 30px 24px;
`;

export const DialogTitle = styled.h2`
  margin: 0 0 ${SPACING.md};
  font-size: 22px;
  font-weight: 700;
  line-height: 1.25;
  color: ${COLOR.navy};
`;

export const DialogLede = styled.p`
  margin: 0 0 18px;
  font-size: ${FONT_SIZE.value};
  line-height: 1.55;
  color: ${COLOR.textSecondary};
`;

export const DialogNote = styled.p`
  margin: ${SPACING.xl} 0 0;
  font-size: ${FONT_SIZE.body};
  line-height: 1.55;
  color: ${COLOR.textSecondary};

  b {
    font-weight: 700;
    color: ${COLOR.text};
  }
`;

export const DialogFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 10px;
  padding: 14px 30px;
  border-top: 1px solid ${COLOR.border};
`;

export const GhostButton = styled(Button)`
  &&& {
    height: 40px;
    padding: 0 6px;
    border: none;
    background: none;
    box-shadow: none;
    font-size: ${FONT_SIZE.value};
    font-weight: 500;
    color: ${COLOR.textSecondary};

    &:hover,
    &:focus {
      background: none;
      color: ${COLOR.text};
    }
  }
`;

export const DialogPrimaryButton = styled(Button)`
  &&& {
    height: 48px;
    padding: 0 ${SPACING.xxl};
    border: none;
    border-radius: ${RADIUS.md};
    background: ${COLOR.primary};
    color: ${COLOR.surface};
    font-size: 15px;
    font-weight: 700;
    box-shadow: none;

    &:hover,
    &:focus {
      background: ${COLOR.primaryDark};
      color: ${COLOR.surface};
    }
  }
`;

export const DangerButton = styled(Button)`
  &&& {
    height: 48px;
    padding: 0 ${SPACING.xxl};
    border: none;
    border-radius: ${RADIUS.md};
    background: ${COLOR.error};
    color: ${COLOR.surface};
    font-size: 15px;
    font-weight: 700;
    box-shadow: none;

    &:hover,
    &:focus {
      background: #dc2626;
      color: ${COLOR.surface};
    }
  }
`;
